export const apiCallCenterSetColaboradorOnline =
  "Api/CallCenter/Set/Colaborador/Online";
export const apiCallCenterStartServiceWithFolio =
  "Api/CallCenter/Start/Service/WithFolio";
export const apiCallCenterSaveConsulta = "Api/CallCenter/Save/Consulta";
export const apiCallCenterGetConsultaDetalle =
  "Api/CallCenter/Get/Consulta/Detalle";
export const apiCallCenterSaveFolioEspecialistaConsulta =
  "Api/CallCenter/Save/Folio/Especialista/Consulta";
export const apiCallCenterCancelarFolioEspecialistaConsulta =
  "Api/CallCenter/Cancelar/Folio/Especialista/Consulta";
export const apiCallCenterIniciarConsulta = "Api/CallCenter/Iniciar/Consulta";
export const apiCallCenterReciclarConsulta = "Api/CallCenter/Reciclar/Consulta";
export const apiCallCenterFinalizarConsulta =
  "Api/CallCenter/Finalizar/Consulta";
export const apiCallCenterGuardarDatosPaciente =
  "Api/CallCenter/Guardar/Datos/Paciente";
export const apiCallCenterGuardarHistorialClinico =
  "Api/CallCenter/Guardar/Historial/Clinico";
export const apiCallCenterGetHistorialClinico =
  "Api/CallCenter/Get/Historial/Clinico";
export const apiCallCenterGetFolioUsuairo = "Api/CallCenter/Get/Folio/Usuario";

export const apiCguCreateModulo = "Api/CGU/Create/Modulo";
export const apiCguCreateSubmodulo = "Api/CGU/Create/SubModulo";
export const apiCguCreateBoton = "Api/CGU/Create/Boton";
export const apiCguCreatePerfil = "Api/CGU/Create/Perfil";
export const apiCguCreateUsuario = "Api/CGU/Create/Usuario";
export const apiCguGetUsuarios = "Api/CGU/Get/Usuarios";
export const apiCguCreateCambiarPassword = "Api/CGU/Create/CambiarContrasenia";
export const apiCguUserLogin = "Api/CGU/User/Login";
export const apiCguRecuperarPassword = "Api/CGU/Recuperar/Password";
export const apiCguGetPermisoPerfil = "Api/CGU/GET/PermisoXPerfil";
export const apiCguGetUsuariosPermisos = "Api/CGU/Get/Usuarios/Permisos";
export const apiCguCreatePermiso = "Api/CGU/Create/Permiso";
export const apiCguGetPerfiles = "Api/CGU/Get/Perfiles";

export const apiColaboradorSaveCallCenterEspecialista =
  "Api/Colaborador/Save/CallCenter/Especialista";
export const apiGetColaboradoresCallCenterEspecialistas =
  "Api/Get/Colaboradores/CallCenter/Especialistas";
export const apiColaboradorSaveFoto = "Api/Colaborador/Save/Foto";
export const apiColaboradorGetFoto = "Api/Colaborador/Get/Foto";
export const apiColaboradorDescargarFoto = "Api/Colaborador/Descargar/Foto";
export const apiColaboradorEliminarFoto = "Api/Colaborador/Eliminar/Foto";
export const apiColaboradorGetDirectorioEspecialistas =
  "Api/Colaborador/Get/Directorio/Especialistas";
export const apiColaboradorGetDirectorioEspecislistasPublico =
  "Api/Colaborador/Get/Directorio/Especialistas/Publico";
export const apiColaboradorGetColaboradorObtenerSala =
  "Api/Colaborador/Get/Colaborador/ObtenerSala";
export const apiColaboradorGetColaboradorEstatus =
  "Api/Colaborador/Get/Colaborador/Status";

export const apiConektaCreateOrder = "Api/Conekta/Create/Order";
export const apiConektaGetOrder = "Api/Conekta/Get/Order";

export const apiEmpresaCreateEmpresa = "Api/Empresa/Create/Empresa";
export const apiEmpresaGetEmpresas = "Api/Empresa/Get/GetEmpresas";

export const apiEspecialidadCreateRegistro =
  "Api/Especialidad/Create/Resgistro";
export const apiEspecialidadGetResgistros = "Api/Especialidad/Get/Registros";
export const apiEspecialidadGetRegistrosFiltrados =
  "Api/Especialidad/Get/RegistrosFiltrados";

export const apiFolioCreateFolio = "Api/Folio/Create/Folio";
export const apiFolioCreateFolioEmpresa = "Api/Folio/Create/FolioEmpresa";
export const apiFolioGetLoginApp = "Api/Folio/Get/LoginApp";
export const apiFolioGetReport = "Api/Folios/Get/Report";
export const apiFolioUpdateFechaVencimiento =
  "Api/Folio/Update/FechaVencimiento";
export const apiFolioDeleteFolioEmpresa = "Api/Folio/Delete/FoliosEmpresa";
export const apiFolioUpdateTerminosCondiciones =
  "Api/Folio/Update/TerminosYCondiciones";
export const apiFolioUpdateFolioPassword = "Api/Folio/Update/FolioPassword";
export const apiFolioVerificarArchivo = "Api/Folio/Verificar/Archivo";
export const apiFolioGenerarFolioArchivo = "Api/Folio/Generar/Folio/Archivo";
export const apiFolioReenviarOrderCorreo = "Api/Folio/Reenviar/Orden/Correo";
export const apiFolioGetFolioVentaCallePlantilla =
  "Api/Folio/Get/Folio/VentaCalle/Plantilla";
export const apiFolioSaveFolioEmpresaComercial =
  "Api/Folio/Save/Folio/Empresa/Comercial";
export const apiFolioSaveFolioClienteLocutorios =
  "Api/Folio/Save/Folio/Cliente/Locutorios";

export const apiPoliticasGetPoliticas = "Api/Politicas/Get/Politicas";
export const apiPoliticasGetSistemaCatalogos =
  "Api/Politicas/Get/Sistema/Catalogos";

export const apiProductoCreateProducto = "Api/Producto/Create/Producto";
export const apiProductoGetObtenerProducto = "Api/Producto/Get/ObtenerProducto";
export const apiProductoGetObtenerMembresia =
  "Api/Producto/Get/ObtenerMembresia";
export const apiProductoGetObtenerServicio = "Api/Producto/Get/ObtenerServicio";
export const apiProductoGetNutricionalPsicologia =
  "Api/Producto/Get/Nutricional/Psicologia";
export const apiProductoGetEmpresaComercial =
  "Api/Producto/Get/Empresa/Comercial";
export const apiProductoGetClienteComercialLocutorios =
  "Api/Producto/Get/Cliente/Comercial/Locutorios";

export const apiPromocionesGuardarCupon = "api/promociones/guardar/cupon";
export const apiPromocionesAplicarCupon = "api/promociones/aplicar/cupon";
export const apiPromocionesValidarCupon = "api/promociones/validar/cupon";
export const apiPromocionesDesactivarCupon = "api/promociones/desactivar/cupon";
export const apiPromocionesObtenerCupones = "api/promociones/obtener/cupones";
export const apiPromocionesValidarCuponEmail =
  "api/promociones/validar/cupon/email";
export const apiPromocionesOBtenerCuponAutocompletar =
  "api/promociones/obtener/cupon/autocompletar";

export const apiReportesVentas = "api/reportes/ventas";
export const apiReportesVentasMeditoc = "api/reportes/ventas/meditoc";
export const apiReportesVentasDescargar = "api/reportes/ventas/descargar";
export const apiReportesDoctores = "api/reportes/doctores";
export const apiReportesDoctoresDescargar = "api/reportes/doctores/descargar";

export const apiAnuncioCrear = "api/Anuncio/Save/Anuncio";
export const apiAnuncioDesactivar = "api/Anuncio/Delete/Anuncio";
export const apiAnuncioObtener = "api/Anuncio/Get/Anuncio";

export const apiEspecialidadInExtGetResgistros =
  "Api/Especialidad/Get/RegistrosIntExt";

export const apiConfirmaCorreo = "Api/UsuarioMeditoc/ConfirmaUsuario";

export const apiMotivoConsultaCreateRegistro = "Api/MotivoConsulta/Create/Resgistro";
export const apiMotivoConsultaGetResgistros = "Api/MotivoConsulta/Get/Registros";